import { GroupIds } from "@/configuration/group-ids";
import { sportOrthoSmsRoutingConfig } from "@/configuration/groups/sportortho/scheduling/sms/routing";
import {
  SchedulingCancellationStrategy,
  SchedulingChannel,
  type SchedulingCustomerConfig,
  SchedulingSmsAvailabilityStrategy,
  SchedulingSmsEligibilityStrategy,
} from "@/customer-interface/scheduling";

/** Common Voice and SMS operations admit live and sandbox cohorts. Caller opt-in is separate. */
export const sportOrthoSchedulingConfig = {
  appointmentQuery: {
    enabledGroupIds: {
      [SchedulingChannel.Sms]: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
    },
  },
  locationQuery: {
    enabledGroupIds: {
      [SchedulingChannel.Sms]: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
    },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/sportortho/rules/schedule.yaml",
  },
  voice: {
    workflowEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
    cancellation: SchedulingCancellationStrategy.Staff,
    optionSearch: {
      progressiveChronologicalWindows: false,
      progressivePolicyRankedWindows: false,
      progressiveLinkedUnitWindows: false,
    },
  },
  sms: {
    routing: sportOrthoSmsRoutingConfig,
    eligibility: SchedulingSmsEligibilityStrategy.Agentic,
    eligibilityEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
    availability: SchedulingSmsAvailabilityStrategy.AgenticProvider,
    availabilityEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
    bookingEnabledGroupIds: [GroupIds.SPORTORTHO_LIVE_SANDBOX, GroupIds.SPORTORTHO_LIVE],
  },
} as const satisfies SchedulingCustomerConfig;
